import React from 'react'
import { VEHICLE_STATE_FORM } from 'constants/qnState'
import { VehicleHeightStatusTypes } from 'states/QnState'
import { useEditQnState } from 'utils/commonHooks'
import AccordionGroup from '../form/AccordionGroup'
import RadioButtonGroup from '../form/RadioButtonGroup'
import { createOptions } from 'utils/commonUtils'

const vehicleHeightTypeOptions = createOptions(
  VEHICLE_STATE_FORM.vehicleHeightStatus.options
)

/** 車両改造選択コンポーネント */
export default function SelectVehicleModificationContent(): JSX.Element {
  const [editState, , setVehicleStateInfo] = useEditQnState()

  const handleVehicleHeightModificationChanged = React.useCallback(
    (isOpened: boolean) => {
      setVehicleStateInfo({
        isVehicleHeightModification: isOpened,
      })
    },
    [setVehicleStateInfo]
  )

  const handleVehicleHeightTypeChanged = React.useCallback(
    (value: VehicleHeightStatusTypes) => {
      setVehicleStateInfo({
        vehicleHeightStatus: value,
      })
    },
    [setVehicleStateInfo]
  )

  return (
    <AccordionGroup
      title={`${VEHICLE_STATE_FORM.vehicleHeightModification.formName}を選択`}
      label={VEHICLE_STATE_FORM.vehicleHeightModification.label}
      isOpened={editState.vehicleStateInfo.isVehicleHeightModification}
      onChanged={handleVehicleHeightModificationChanged}
    >
      <div style={{ background: '#FFFFFF' }}>
        <RadioButtonGroup
          title={VEHICLE_STATE_FORM.vehicleHeightStatus.formName}
          hideTitle={true}
          options={vehicleHeightTypeOptions}
          selectedValue={editState.vehicleStateInfo.vehicleHeightStatus}
          onValueChanged={handleVehicleHeightTypeChanged}
        />
      </div>
    </AccordionGroup>
  )
}
